<div class="form">
  <div class="container">
    <div id="myPaymentForm">
      <div
        class="kr-smart-form"
        kr-no-card-logo-header>
        <div class="kr-embedded">
          <label
            for="kr-card-holder-name"
            class="text-sm"
            >{{ "paymentForm.cardName" | translate }}
            <span class="text-primary">{{ "paymentForm.required" | translate }}</span></label
          >
          <div class="kr-card-holder-name"></div>
          <label
            for="kr-pan"
            class="text-sm"
            >{{ "paymentForm.cardNumber" | translate }}
            <span class="text-primary">{{ "paymentForm.required" | translate }}</span></label
          >
          <div class="kr-pan"></div>
          <label
            for="kr-expiry"
            class="text-sm"
            >{{ "paymentForm.expiryDate" | translate }}
            <span class="text-primary">{{ "paymentForm.required" | translate }}</span></label
          >
          <div class="kr-expiry"></div>
          <label
            for="kr-security-code"
            class="text-sm"
            >{{ "paymentForm.securityCode" | translate }}
            <span class="text-primary">{{ "paymentForm.required" | translate }}</span></label
          >
          <div class="kr-security-code"></div>
          <div class="custom-buttons">
            <button class="kr-payment-button">
              {{ "paymentForm.submit" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div data-test="payment-message">{{ message }}</div>
  </div>
</div>
